import { compose } from 'recompose';

import UserCardView from './UserCardView';

export default compose()(UserCardView);
